module.exports = __webpack_public_path__ + "img/driver_pin.5387444d.svg";